import { render, staticRenderFns } from "./Waiting.vue?vue&type=template&id=6955b65a&scoped=true&"
import script from "./Waiting.vue?vue&type=script&lang=ts&"
export * from "./Waiting.vue?vue&type=script&lang=ts&"
import style0 from "./Waiting.vue?vue&type=style&index=0&id=6955b65a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6955b65a",
  null
  
)

export default component.exports